import React, { useState } from "react";
import {
  menuUrl,
  tableTitle,
  keyColumn,
  tableColumn,
  breadCrumbs,
  filters as rawFilters,
  additionalActions
} from "@screens/user-administration/roles/roles-list/model/roles-list.constants";
import { getFilterData } from "@utils/common";
import {
  constructFilterDataAndGetQueryString,
  getFilterQueryString,
} from "@utils/filters.util";
import { APP } from "@constants/app.constants";
import { useHistory } from "react-router-dom";
import { checkMenuAccess } from "@utils/menu-auth";
import {
  deleteRolesDataApi,
  getRolesDataApi,
} from "./roles-list.component.service";
import MESSAGES from "@constants/messages.constants";
import { useDispatch, useSelector } from "react-redux";
import { setAlertMessage } from "@reducers/alert.reducer";
import RolesListTemplateComponent from "./roles-list-template.component";
import PermissionDeniedComponent from "@screens/permission-denied/permission-denied.component";

const {
  ALERT_TYPES: { SUCCESS, ERROR },
  ROLE_ALERTS: { DELETE_ALERT },
} = MESSAGES;
const { ROWS_PER_PAGE } = APP;

const RolesListComponent = () => {
  const { filterList } = useSelector((state) => state.filter);
  const [tableData, setTableData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const history = useHistory();
  const dispatch = useDispatch();
  const filters = getFilterData(filterList, menuUrl, "filter");
  const menuAccess = checkMenuAccess(menuUrl, "read");

  const getRolesData = async (params = null) => {
    // console.log({ params });
    const queryStr = getFilterQueryString(menuUrl, params);
    const rolesData = await getRolesDataApi({
      ...params,
      filters: queryStr,
    });
    if (rolesData.status) {
      // console.log(rolesData);
      setTableData(rolesData.data);
      setTotalCount(rolesData.totalCount);
    }
  };

  const handleCreateClick = () => {
    history.push(`/${menuUrl}/create`);
  };

  const deleteRecords = async (selected) => {
    const deleteAccess = checkMenuAccess(menuUrl, "delete");
    if (deleteAccess) {
      const response = await deleteRolesDataApi(selected);
      if (response.status) {
        dispatch(
          setAlertMessage({ type: SUCCESS, message: DELETE_ALERT, viewed: 0 })
        );
        getRolesData({
          orderBy: "created_at",
          sortBy: "desc",
          skip: 0,
          limit: ROWS_PER_PAGE,
        });
      } else {
        dispatch(
          setAlertMessage({ type: ERROR, message: response.message, viewed: 0 })
        );
      }
    } else
      dispatch(
        setAlertMessage({
          type: ERROR,
          message: "Permission denied to delete",
          viewed: 0,
        })
      );
  };

  const handleDownload = async (filters = null) => {
    const queryStr = getFilterQueryString(menuUrl, filters);
    // console.log("download triggered", filters, queryStr);
    // // console.log({
    //   url: `${SETTING_EXPORT}?token=${token}${queryStr}`,
    // });
  };

  const submitFilter = (filters) => {
    const queryStr = constructFilterDataAndGetQueryString(filters, menuUrl);
    // console.log({ queryStr });
    getRolesData({
      orderBy: "created_at",
      sortBy: "desc",
      skip: 0,
      limit: ROWS_PER_PAGE,
      filters: queryStr,
    });
  };

  const handleCloneClick = (row) => {
    console.log("Clone Clicked!", row);
    history.push({
      pathname: `roles/clone`,
      state: { row, type: "clone" },
    });
  };

  return menuAccess ? (
    <RolesListTemplateComponent
      templateModal={{
        tableTitle,
        keyColumn,
        breadCrumbs,
        tableColumn,
        tableData,
        totalCount,
        filters: filters ? filters : rawFilters,
        tableActions: additionalActions({ handleCloneClick }),
      }}
      templateEvents={{
        getRolesData,
        handleCreateClick,
        deleteRecords,
        handleDownload,
        submitFilter,
      }}
    />
  ) : (
    <PermissionDeniedComponent />
  );
};

export default RolesListComponent;
